// extracted by mini-css-extract-plugin
module.exports = {"valueSuggestionsList":"ValueSuggestionsList_valueSuggestionsList__1TQoH"};